export default {
  isModalOpen: (state, getters) => {
    return (params) => getters.findModal(params) != undefined
  },
  findModal: (state) => {
    return (params) => [...state.modals].reverse().find((modal) => modal[params.type] === params.value)
  },
  getModals: (state) => {
    return state.modals
  },
  getLastModal: (state, getters) => {
    let modals = getters.getModals
    return modals[modals.length - 1]
  },
  isDirtyGuarded: (state) => {
    return (modal_id) => (state.dirtyGuard || {})[modal_id] === true
  }
}
